module.exports = __webpack_public_path__ + "static/images/banner.0bf33b6.jpg";